var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"ref__googlemaps",staticClass:"container__googlemaps__position",attrs:{"map-type-id":"satellite","center":{ lat: 0, lng: 0 },"zoom":2,"options":{
			mapTypeControl: false,
			scaleControl: false,
			zoomControl: false,
			streetViewControl: false,
			fullscreenControl: false,
		}},scopedSlots:_vm._u([{key:"visible",fn:function(){return [_vm._t("default"),(_vm.getGeoJsonPtio.features)?_c('div',{staticClass:"px-2 py-1 bg-white rounded-full z-1 relative w-fit my-4 float-right"},[_c('Switcher',{attrs:{"label":_vm.$t('showPlantationInfo'),"value":_vm.showMarkers},on:{"input":function($event){return _vm.setShowMarkers($event)}}})],1):_vm._e()]},proxy:true}],null,true)},[_c('GmapCluster',{attrs:{"max-zoom":10,"zoom-on-click":true,"styles":[
				{
					width: 30,
					height: 30,
					className: 'custom-clustericon-1',
				},
				{
					width: 40,
					height: 40,
					className: 'custom-clustericon-2',
				},
				{
					width: 50,
					height: 50,
					className: 'custom-clustericon-3',
				},
			],"cluster-class":"custom-clustericon"}},[(_vm.isDashboardGeral)?_c('div',_vm._l((_vm.cardInfoWithInfoGeo),function(dataIndividual,index){return _c('gmap-marker',{key:index,attrs:{"position":{
						lat: dataIndividual.infoGeo.centroId.coordinates[1],
						lng: dataIndividual.infoGeo.centroId.coordinates[0],
					}}})}),1):_vm._e()]),(_vm.showMarkers)?_c('div',_vm._l((_vm.plantioMarkers),function(plantioMarker){return _c('PlantioMarker',{key:plantioMarker.infoPoligono.centroId.coordinates.toString(),attrs:{"plantio-marker":{ ...plantioMarker, variavel: _vm.findVariavelByCode(plantioMarker.codigo) }}})}),1):_vm._e(),_vm._l((_vm.getGeoJsonPtio.features),function(coordinateAndType,index){return _c('PolygonShape',{key:coordinateAndType.properties['Codigo Plantio'] + index,attrs:{"options":{
				fillColor: _vm.findColorByCode(coordinateAndType.properties['Codigo Plantio']),
				strokeColor: _vm.findColorByCode(coordinateAndType.properties['Codigo Plantio']),
				strokeOpacity: 1,
				fillOpacity: 0.6,
				strokeWeight: 2,
				zIndex: 10,
			},"coordinates":coordinateAndType.geometry.coordinates,"type":coordinateAndType.geometry.type,"properties":coordinateAndType.properties,"clickable":true}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }